import { HttpRequestStatus } from '../../model/enums/httpRequestStatus';
import { useCompanyDefaultState, useUserAccountState } from '../../reducer/hooks';

export const useDoesHeaderProviderHasError = () => {
    const accountState = useUserAccountState();
    const companyState = useCompanyDefaultState();

    return accountState.status === HttpRequestStatus.ERROR || companyState.status === HttpRequestStatus.ERROR;
};
